export function MyAreaTitle({ title, className = "" }: { title: string, className?: string }) {
    return (
        <h1 className={`font-bold lg:mb-5 text-Yellow-default text-xl text-center lg:text-left ${className}`}>
            {title.toUpperCase()}
        </h1>
    )
}